export const CONTAINER_MAX_W = '880px';
export const CONTAINER_PX = { base: '24px', md: '32px' };
